import { create } from 'zustand';

export interface AuthUser {
  id: string;
  email: string;
  role: 'user' | 'platform_admin';
  full_name?: string;
  avatar_url?: string;
}

interface AuthState {
  status: 'loading' | 'anon' | 'authed';
  accessToken: string | null;
  user: AuthUser | null;
  set: (s: Partial<Omit<AuthState, 'set'>>) => void;
}

export const useAuth = create<AuthState>((set) => ({
  status: 'loading',
  accessToken: null,
  user: null,
  set: (s) => set(s),
}));
